import axios from 'axios';
import { INVENSE_API_URL } from '../config';

export const invenseAxios = axios.create({
  baseURL: INVENSE_API_URL,
});
